export { default as CertifiedBadge } from './certified-badge.svg'
export { default as Profile } from './profile.svg'
